import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', // 默认中文，从localStorage读取
  fallbackLocale: 'en', // 备用语言
  messages: { en, zh }
})

export default i18n